<template>
  <InformationItem v-bind="$props" :items="formattedItems">
    <template v-slot:title>Ids</template>
  </InformationItem>
</template>

<script>
import InformationItem from './InformationItem';
import valueFormatterMixins from './mixins/valueFormatterMixins';

export default {
  components: { InformationItem },
  props: ['items', 'itemType'],
  mixins: [valueFormatterMixins],
};
</script>
